import * as SearchConstants from './constants';

export const searchOptionsConfig = [
  {
    text: 'Name',
    value: SearchConstants.SEARCH_BY_NAME,
  },
  {
    text: 'City',
    value: SearchConstants.SEARCH_BY_CITY,
  },
  {
    text: 'U.S. State',
    value: SearchConstants.SEARCH_BY_STATE,
  },
];

export const premiumSearchOptionsConfig = [
  {
    text: 'U.S. County',
    value: SearchConstants.SEARCH_BY_COUNTY,
  },
  {
    text: 'U.S. Zip Code',
    value: SearchConstants.SEARCH_BY_ZIP,
  },
  {
    text: 'CEEB Code',
    value: SearchConstants.SEARCH_BY_CEEB,
  },
  {
    text: 'Country',
    value: SearchConstants.SEARCH_BY_COUNTRY,
  },
];
